module.exports = __webpack_public_path__ + "static/flask-318d58cbc47ace3e1baf4f035cab5b53.svg";